import { render, staticRenderFns } from "./OfflineManager.vue?vue&type=template&id=48b96d44"
import script from "./OfflineManager.vue?vue&type=script&lang=js"
export * from "./OfflineManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports